import {
    Button,
    Menu,
    MenuDivider,
    MenuItem,
    Navbar,
    NavbarDivider,
    Popover,
    Tag
} from '@blueprintjs/core';
import { AlloyInstance } from 'alloy-ts';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../rootReducer';
import { setInstance, setLoop } from '../../sterling/sterlingSlice';
import { addProjection, setScript } from '../script/scriptSlice';
import ViewGroup from './components/ViewGroup';

const mapState = (state: RootState) => ({
    instance: state.sterlingSlice.instance
});

const mapDispatch = {
    setInstance,
    setScript,
    setLoop,
    addProjection
};

const connector = connect(
    mapState,
    mapDispatch
);

type StaticNavbarProps = ConnectedProps<typeof connector>;

function parseMultiInstance (text: string): { instances: AlloyInstance[], loop: string } {

    return {
        instances: [new AlloyInstance(text)],
        loop: ''
    };

    // const parser = new DOMParser();
    // const serializer = new XMLSerializer();
    // const originalxml = parser.parseFromString(text, 'application/xml');
    // const originalalloy = originalxml.querySelector('alloy');
    // if (!originalalloy) return {
    //     instances: [],
    //     loop: ''
    // };
    // const builddate = originalalloy.getAttribute('builddate') || '';
    //
    // const inst = originalalloy.querySelector('instance');
    // if (!inst) return {
    //     instances: [],
    //     loop: ''
    // };
    //
    // const loop = inst.getAttribute('loop');
    //
    // return {
    //     instances: Array.from(originalalloy.querySelectorAll('instance')).map(element => {
    //         const doc = document.implementation.createDocument(null, 'alloy', null);
    //         const alloy = doc.querySelector('alloy');
    //         if (alloy) {
    //             alloy.setAttribute('builddate', builddate);
    //             alloy.appendChild(element);
    //         }
    //         const instancetext = serializer.serializeToString(doc);
    //         return new AlloyInstance(instancetext);
    //     }),
    //     loop: loop || ''
    // };
}


const StaticNavbar: React.FunctionComponent<StaticNavbarProps> = props => {

    const command = props.instance.length ? props.instance[0].command() : '';
    const fileref = React.createRef<HTMLInputElement>();

    const setInstance = (text: string | ArrayBuffer | null) => {
        if (typeof text === 'string' && text.length) {
            try {
                const { instances, loop } = parseMultiInstance(text);
                props.setInstance(instances);
                props.setLoop(loop);
            } catch (e) {
                props.setInstance([]);
            }
        } else {
            props.setInstance([]);
        }
    };

    const setScript = (text: string | ArrayBuffer | null) => {
        if (typeof text === 'string' && text.length) {
            try {
                props.setScript(text)
            } catch (e) {
                props.setScript('');
            }
        }
    }

    const onFileChange = () => {
        if (fileref.current) {
            const files = fileref.current.files;
            if (files && files.length) {
                const file = files[0];
                const reader = new FileReader();
                reader.addEventListener('load', event => {
                    setInstance(event.target ? event.target.result : null);
                });
                reader.readAsText(file);
            }
        }
    };

    const fetchExample = (path: string, scriptPath?: string, projection?: string) => {
        fetch(path)
            .then(response => response.text())
            .then(setInstance)
            .then(() => {
                if (projection) props.addProjection(projection);
            })
            .catch(() => setInstance(null));
        if (scriptPath) {
            fetch(scriptPath)
                .then(response => response.text())
                .then(setScript)
                .catch(() => setScript(''));
        }
    };

    return (
        <Navbar fixedToTop className={'nav bp3-dark'}>
            <ViewGroup/>
            <Navbar.Group className={'collapsing'}>
                {
                    command.length > 0 &&
                    <Tag minimal={true}>
                        { command }
                    </Tag>
                }
                <NavbarDivider/>
                <input
                    type={'file'}
                    style={{ display: 'none' }}
                    onChange={onFileChange}
                    ref={fileref}/>
                <Popover>
                    <Button
                        rightIcon={'caret-down'}
                        intent={'success'}
                        large={true}
                        text={'Open'}/>
                    <Menu>
                        <MenuItem
                            text={'Open XML...'}
                            onClick={() => {
                                if (fileref.current) {
                                    fileref.current.click();
                                }
                            }}/>
                        <MenuDivider title={'Examples'}/>
                        <MenuItem
                            text={'Finite Element Mesh'}
                            onClick={() => fetchExample('examples/mesh.xml', 'examples/mesh.js')}/>
                        <MenuItem
                            text={'Mathematical Matrix'}
                            onClick={() => fetchExample('examples/matrix.xml', 'examples/matrix.js')}/>
                        <MenuItem
                            text={'Dining Philosophers'}
                            onClick={() => fetchExample('examples/philosophers.xml', 'examples/philosophers.js', 'this/State')}/>
                        <MenuItem
                            text={'River Crossing Puzzle'}
                            onClick={() => fetchExample('examples/river-crossing.xml', 'examples/river.js', 'this/State')}/>
                    </Menu>
                </Popover>
            </Navbar.Group>
        </Navbar>
    )
};

export default connector(StaticNavbar);
